import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import {
    TransactionEntryCategoriesDocument,
    TransactionEntryCategoryFieldsFragment,
} from '../../graphql/generated';
import { sampleTransactionEntryCategories } from '../../sampleData';
import { useHasNoFEs } from '../financialEntities';

export const useTransactionEntryCategories = () => {
    const hasNoFEs = useHasNoFEs();

    const {
        data: transactionEntryCategoriesQuery,
        loading: transactionEntryCategoriesLoading,
        refetch,
    } = useQuery(TransactionEntryCategoriesDocument);

    const transactionEntryCategoriesMapById = useMemo(() => {
        const categories = hasNoFEs
            ? sampleTransactionEntryCategories
            : transactionEntryCategoriesQuery?.transactionEntryCategories;

        if (!categories) return;

        return buildTransactionEntryCategoriesMapById(categories);
    }, [hasNoFEs, transactionEntryCategoriesQuery?.transactionEntryCategories]);

    return {
        transactionEntryCategories: hasNoFEs
            ? sampleTransactionEntryCategories
            : transactionEntryCategoriesQuery?.transactionEntryCategories ?? [],
        transactionEntryCategoriesMapById,
        transactionEntryCategoriesLoading,
        refetch,
    };
};

const buildTransactionEntryCategoriesMapById = (
    transactionEntryCategories: TransactionEntryCategoryFieldsFragment[]
) =>
    transactionEntryCategories.reduce(
        (
            map: Record<string, TransactionEntryCategoryFieldsFragment>,
            category
        ) => {
            map[category.id] = category;
            return map;
        },
        {}
    );
